<template>
  <footer class="site-footer" role="contentinfo">
    <div class="site-footer__inner flex-row">
      <div class="site-footer__left flex-col justify-between">
        <nav class="site-footer__nav flex-row" aria-label="页脚导航">
          <router-link
            v-for="item in navItems"
            :key="item.to"
            class="site-footer__nav-link"
            :to="item.to"
            :exact="!!item.exact"
          >{{ item.label }}</router-link>
        </nav>
        <p class="site-footer__meta">
          版权所有：人工智能+数字人+商场创新应用服务平台&nbsp;人工智能数字人商城注册服务中心
          <br />
          京ICP备18024298号-53
          <br />
          技术支持：北京智创映科技有限公司
          <br />
          公司地址：北京市平谷区南独乐河镇同乐路145号26068
        </p>
      </div>
      <div class="site-footer__contact flex-col justify-between" v-if="false">
        <span class="site-footer__contact-title">联系我们</span>
        <div class="site-footer__phone flex-row justify-between">
          <img class="site-footer__phone-icon" :src="phoneIcon" alt="" />
          <span class="site-footer__phone-num">400-652-1008</span>
        </div>
      </div>
      <div class="site-footer__qr flex-col justify-between" v-if="false">
        <div
          class="site-footer__qr-img"
          :style="{ backgroundImage: `url(${qrImg})` }"
          role="img"
          aria-label="微信公众号二维码"
        />
        <span class="site-footer__qr-cap">北京智创映微信公众号</span>
      </div>
    </div>
  </footer>
</template>

<script>
import phoneIcon from '@/views/lanhu_shouye/assets/img/SketchPng02cb407c99139c4335a332bf00c23db9011d8185a8d66df66d0c29fd62e88622.png';
import qrImg from '@/views/lanhu_shouye/assets/img/753f39f5f61f4f78841a7b85458b5d51_mergeImage.png';

export default {
  name: 'SiteFooter',
  data() {
    return {
      phoneIcon,
      qrImg,
      navItems: [
        { to: '/lanhu_shouye', label: '首页', exact: true },
        { to: '/lanhu_guanyuwomen', label: '关于我们' },
        { to: '/lanhu_zixunzhongxin', label: '资讯中心' },
        { to: '/lanhu_fuwushang', label: '服务商' },
        { to: '/lanhu_fuchizhengce', label: '扶持政策' }
      ]
    };
  }
};
</script>

<style scoped lang="less">
.site-footer {
  width: 1240px;
  max-width: 100%;
  margin: 60px auto;
  padding: 0 24px;
  box-sizing: border-box;
}
.site-footer__inner {
  width: 100%;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px 32px;
}
.site-footer__left {
  flex: 1 1 320px;
  min-width: 0;
  max-width: 540px;
}
.site-footer__nav {
  flex-wrap: wrap;
  gap: 12px 32px;
  max-width: 472px;
}
.site-footer__nav-link {
  color: rgba(25, 25, 25, 1);
  font-size: 16px;
  line-height: 22px;
  text-decoration: none;
  white-space: nowrap;
}
.site-footer__nav-link:hover {
  color: rgba(7, 98, 203, 0.95);
}
.site-footer__meta {
  margin: 20px 0 0;
  color: rgba(167, 167, 167, 1);
  font-size: 14px;
  line-height: 30px;
  text-align: left;
}
.site-footer__contact {
  flex: 0 0 auto;
  width: 124px;
}
.site-footer__contact-title {
  color: rgba(25, 25, 25, 1);
  font-size: 16px;
  line-height: 22px;
}
.site-footer__phone {
  width: 124px;
  margin-top: 12px;
  align-items: center;
}
.site-footer__phone-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.site-footer__phone-num {
  color: rgba(25, 25, 25, 1);
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  margin-left: 6px;
}
.site-footer__qr {
  flex: 0 0 auto;
  width: 110px;
  align-items: center;
}
.site-footer__qr-img {
  width: 91px;
  height: 91px;
  margin-left: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.site-footer__qr-cap {
  margin-top: 6px;
  color: rgba(25, 25, 25, 1);
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;
}
@media (max-width: 900px) {
  .site-footer {
    margin: 40px auto;
    padding: 0 16px;
  }
  .site-footer__inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .site-footer__contact,
  .site-footer__qr {
    margin-left: 0;
  }
}
</style>
